export const CASH_SYNC_INVALID_STATION_CONTEXT = 'INVALID_STATION_CONTEXT';
export const CASH_SYNC_UNKNOWN_CASH_LOCATION = 'UNKNOWN_CASH_LOCATION';
export const CASH_SYNC_DISABLED_CATEGORY = 'DISABLED_CATEGORY';
export const CASH_SYNC_TREASURY_BLOCKED = 'TREASURY_BLOCKED';
export const CASH_SYNC_INVARIANT_VIOLATION = 'INVARIANT_VIOLATION';
export const CASH_SYNC_IDEMPOTENCY_CONFLICT = 'IDEMPOTENCY_CONFLICT';
export const CASH_SYNC_STALE_TRANSITION = 'STALE_TRANSITION';
export const CASH_SYNC_ALREADY_FULFILLED = 'ALREADY_FULFILLED';
export const CASH_SYNC_TERMINAL_STATE_CONFLICT = 'TERMINAL_STATE_CONFLICT';
export const CASH_SYNC_TRANSACTION_CONFLICT = 'CASH_SYNC_TRANSACTION_CONFLICT';
export const CASH_SYNC_ACTOR_INVALID = 'SYNC_ACTOR_INVALID';
export const CASH_SYNC_PREREQUISITE_INACTIVE = 'CASH_PREREQUISITE_INACTIVE';

export const cashSyncErrorCodes = [
  CASH_SYNC_INVALID_STATION_CONTEXT,
  CASH_SYNC_UNKNOWN_CASH_LOCATION,
  CASH_SYNC_DISABLED_CATEGORY,
  CASH_SYNC_TREASURY_BLOCKED,
  CASH_SYNC_INVARIANT_VIOLATION,
  CASH_SYNC_IDEMPOTENCY_CONFLICT,
  CASH_SYNC_STALE_TRANSITION,
  CASH_SYNC_ALREADY_FULFILLED,
  CASH_SYNC_TERMINAL_STATE_CONFLICT,
  CASH_SYNC_TRANSACTION_CONFLICT,
  CASH_SYNC_ACTOR_INVALID,
  CASH_SYNC_PREREQUISITE_INACTIVE,
] as const;

export type CashSyncErrorCode = (typeof cashSyncErrorCodes)[number];
